module.exports = __webpack_public_path__ + "static/media/05-benefit-social-content.20d37df6.jpg";